import React from "react";
import styles from "./styles.css";
import Modal from "../../shared/modal";
import closeIcon from "./images/close.svg";
import PropTypes from "prop-types";
import CarUspContainer from "../car-usp-container";

const CarGalleryModal = (
    {
        onClose,
        imageData,
        isDealerListing
    }
) => {
    const {imagePath} = imageData || {};
    return (
        <Modal isOpen={true} overlayClass="videoGallerySlider">
            <div styleName={"styles.outer"}>
                <div onClick={onClose} styleName={"styles.closeWrapper"}>
                    <p styleName={"styles.close"}>Close<img src={closeIcon} /></p>
                </div>
                <div styleName={"styles.imageWrapper"}>
                    <img style={{objectFit: isDealerListing ? "cover" : ""}} src={imagePath} />
                    {imageData.items && <CarUspContainer slideData={imageData} />}
                </div>
            </div>
        </Modal>
    );
};

CarGalleryModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    imageData: PropTypes.object,
    isDealerListing: PropTypes.bool
};

export default CarGalleryModal;
